// InstructionsPage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ExamInstructions from "./ExamInstructions";
import axios from "axios";
import { useLocation } from "react-router-dom";

export default function Instructions() {
  const navigate = useNavigate();
  const location = useLocation();
  const [examData, setExamData] = useState(location.state || null);

  // State that will be passed to custom hook in ExamPage
  const [exam, setExam] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [timeLeft, setTimeLeft] = useState(0);

  // Get examData from sessionStorage
  useEffect(() => {
     if (!examData) {
      console.error("No Assessment data found!");
      navigate("/"); // Redirect back or handle gracefully
    }
    console.log(examData,"examDataaaaaaaaaaaaaa")
  }, [examData, navigate]);


  const enterFullscreen = async () => {
  const elem = document.documentElement;

  try {
    if (elem.requestFullscreen) {
      await elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      await elem.webkitRequestFullscreen(); // Safari
    } else if (elem.msRequestFullscreen) {
      await elem.msRequestFullscreen(); // IE/Edge
    }
  } catch (err) {
    console.error("Fullscreen failed:", err);
  }
};

  



  // const handleStart = () => {
  //  console.log("Assessment started:", JSON.stringify(examData, null, 2));

  // };


  const handleStart = async () => {

  try {

    await enterFullscreen();

    const payload = {
      exam_id: examData.examId,
      exam_title: examData.examTitle,
      area: examData.area,
      topic: examData.topic,
      subtopic: examData.subtopic,
      exam_purpose:examData.examPurpose,
      status: examData.status,
    };

    const response = await axios.post(
      "/employee/submit-exam/",
      payload,
      {
        withCredentials: true,
      }
    );

    console.log(response.data);

    // DIRECT NAVIGATION WITH QUESTIONS
    navigate("/exam", {
      state: {
        examData: response.data
      },
    });

  } catch (error) {
    console.error("Error starting exam:", error);
    const errorMessage =
      error.response?.data?.details?.message ||
      error.response?.data?.details?.error ||
      error.response?.data?.message ||
      error.response?.data?.error ||
      "Failed to start Assessment. Try again.";
    alert(errorMessage);
  }
};

  // if (!examData) return <div>Loading instructions...</div>;

  return <ExamInstructions examData={examData} onStart={handleStart} />;
}
